import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import Box, { BoxProps } from 'ui-box';
import { defaultFills, Icon, minorScale } from '../../npaper';
import { ISale, SaleType, useStores } from '../../stores';

export const SaleThumbnail = ({
  showNumber = true,
  showTitle = false,
  sale,
  size = 24,
  ...props
}: {
  showNumber?: boolean;
  showTitle?: boolean;
  sale?: ISale;
  size?: number;
} & BoxProps<any>) => {
  const type = sale ? sale.type : SaleType.INVOICE;
  const { authStore } = useStores();
  return (
    <Box
      {...props}
      className={classNames(props.className, 'a')}
      display="inline-flex"
      alignItems="center"
      is={Link}
      to={`/sales/${sale ? sale.id : 'TODO'}`}
    >
      <Box
        borderRadius={size / 2}
        width={size}
        height={size}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        marginRight={showNumber ? minorScale(1) : 0}
        backgroundColor={
          type === SaleType.OFFER
            ? defaultFills.normal[100]
            : type === SaleType.ORDER
            ? defaultFills.primary[100]
            : defaultFills.success[100]
        }
      >
        <Icon
          icon={
            type === SaleType.OFFER
              ? 'lightbulb'
              : type === SaleType.ORDER
              ? 'shopping-cart'
              : 'dollar'
          }
          color={
            type === SaleType.OFFER
              ? defaultFills.normal[500]
              : type === SaleType.ORDER
              ? defaultFills.primary[500]
              : defaultFills.success[600]
          }
          size={size / 2}
        />
      </Box>
      {showNumber && (
        <p className="elipsis">
          <span className="font-mono">
            {sale
              ? type === SaleType.OFFER
                ? sale.offer_number ||
                  `(${authStore.currentOrganisation!.next_offer_number})`
                : type === SaleType.ORDER
                ? sale.order_number ||
                  `(${authStore.currentOrganisation!.next_order_number})`
                : sale.invoice_number ||
                  `(${authStore.currentOrganisation!.next_invoice_number})`
              : 'TODO'}
          </span>
          {sale && showTitle && ` ${sale.title}`}
        </p>
      )}
    </Box>
  );
};
